import { render, staticRenderFns } from "./WrappingTreatment.vue?vue&type=template&id=c9113370&"
import script from "./WrappingTreatment.vue?vue&type=script&lang=ts&"
export * from "./WrappingTreatment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports